var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.694,
    height: 15.694,
    viewBox: "0 0 15.694 15.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hot-tub",
    "data-name": "Icon awesome-hot-tub",
    d: "M12.7,5.446a.493.493,0,0,0,.483.44h.494a.5.5,0,0,0,.49-.562,4.469,4.469,0,0,0-1.537-2.978A2.907,2.907,0,0,1,11.647.44.492.492,0,0,0,11.165,0h-.494a.5.5,0,0,0-.49.562,4.469,4.469,0,0,0,1.537,2.978A2.907,2.907,0,0,1,12.7,5.446Zm-3.311,0a.493.493,0,0,0,.483.44h.494a.5.5,0,0,0,.49-.562A4.469,4.469,0,0,0,9.317,2.345,2.907,2.907,0,0,1,8.337.44.492.492,0,0,0,7.854,0H7.36a.5.5,0,0,0-.49.562A4.469,4.469,0,0,0,8.406,3.541,2.907,2.907,0,0,1,9.386,5.446Zm5.327,2.4H7.847L4.447,5.3A1.961,1.961,0,0,0,3.27,4.9H1.962A1.962,1.962,0,0,0,0,6.866v6.866a1.962,1.962,0,0,0,1.962,1.962H13.733a1.962,1.962,0,0,0,1.962-1.962v-4.9A.981.981,0,0,0,14.713,7.847Zm-10.79,5.64a.245.245,0,0,1-.245.245h-.49a.245.245,0,0,1-.245-.245V10.054a.245.245,0,0,1,.245-.245h.49a.245.245,0,0,1,.245.245Zm2.943,0a.245.245,0,0,1-.245.245h-.49a.245.245,0,0,1-.245-.245V10.054a.245.245,0,0,1,.245-.245h.49a.245.245,0,0,1,.245.245Zm2.943,0a.245.245,0,0,1-.245.245h-.49a.245.245,0,0,1-.245-.245V10.054a.245.245,0,0,1,.245-.245h.49a.245.245,0,0,1,.245.245Zm2.943,0a.245.245,0,0,1-.245.245h-.49a.245.245,0,0,1-.245-.245V10.054a.245.245,0,0,1,.245-.245h.49a.245.245,0,0,1,.245.245ZM1.962,3.924A1.962,1.962,0,1,0,0,1.962,1.962,1.962,0,0,0,1.962,3.924Z",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.bb7dfe87ea02f10d87e7df46c2fd1889.svg";
export { ForwardRef as ReactComponent };